// extracted by mini-css-extract-plugin
module.exports = {"title":"Wcx3LG","chooseGiftSizeModal":"_2O-xv9","offers":"_1OU_Yb","shine-lines":"_24OKo-"};